import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Button, Modal, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useTicketData } from "../..";
import { Ticket } from "../../../../../js/parsegenerated";

const { Text } = Typography;

export const TicketDeleteModal = observer(
  (props: { onOk: Function; onCancel: Function; open: boolean }) => {
    const t = useTranslation();
    const [loading, setLoading] = useState(false);
    const { message } = useFeedback();
    const ticketData = useTicketData();

    const deleteTicket = async () => {
      setLoading(true);
      ticketData.ticket.set("enabled", false);
      ticketData.ticket.save().then(
        (deletedticket: Ticket) => {
          setLoading(false);
          message.success(t("maintenance:global.messages.delete.success"), 10);
          props.onOk();
        },
        (error: Parse.Error) => {
          setLoading(false);
          message.error(t("maintenance:global.messages.delete.error"), 10);
        }
      );
    };

    return (
      <>
        <Modal
          title={t("maintenance:ticket.delete.headline")}
          open={props.open}
          onOk={deleteTicket}
          onCancel={() => {
            props.onCancel();
          }}
          width={"80%"}
          getContainer={false}
          footer={[
            <Button
              key="back"
              onClick={() => {
                props.onCancel();
              }}
            >
              {t("maintenance:global.button.cancel_label")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={deleteTicket}
              danger
            >
              {t("maintenance:global.button.delete_label")}
            </Button>,
          ]}
        >
          {t("maintenance:ticket.delete.content.1")}
          <Text type="warning">{ticketData.ticket.id}</Text>
          {t("maintenance:ticket.delete.content.2")}
        </Modal>
      </>
    );
  }
);
